

export default function ApplicantTable({
  pipelineSearch,
  setPipelineSearch,
  pipelineRoleFilter,
  setPipelineRoleFilter,
  pipelineFacilityFilter,
  setPipelineFacilityFilter,
  pipelineSourceFilter,
  setPipelineSourceFilter,
  pipelineStageFilter,
  setPipelineStageFilter,
  children,
}) {
    
  return (
    <div
      style={{
        padding: 16,
        borderRadius: 16,
        background: "#ffffff",
        border: "1px solid #e2e8f0",
      }}
    >
      <div
        style={{
          fontSize: 18,
          fontWeight: 950,
          marginBottom: 12,
        }}
      >
        Applicants Pipeline
      </div>

      <div className="ao-filters">
        <select
          value={pipelineRoleFilter}
          onChange={(e) => setPipelineRoleFilter(e.target.value)}
          style={{
            padding: 10,
            borderRadius: 10,
            border: "1px solid #cbd5e1",
            fontWeight: 800,
          }}
        >
          <option value="all">All roles</option>
          <option value="worker">Worker</option>
          <option value="cna">CNA</option>
          <option value="lvn">LVN</option>
          <option value="rn">RN</option>
          <option value="med_aide">Med Aide</option>
          <option value="caregiver">Caregiver</option>
        </select>

        <select
          value={pipelineFacilityFilter}
          onChange={(e) => setPipelineFacilityFilter(e.target.value)}
          style={{
            padding: 10,
            borderRadius: 10,
            border: "1px solid #cbd5e1",
            fontWeight: 800,
          }}
        >
          <option value="all">All facilities</option>
          <option value="bridge_rehab">Bridge Rehab</option>
          <option value="hilltop">Hilltop</option>
          <option value="collegepark">College Park</option>
          <option value="parkwood">Parkwood</option>
        </select>

        <select
          value={pipelineSourceFilter}
          onChange={(e) => setPipelineSourceFilter(e.target.value)}
          style={{
            padding: 10,
            borderRadius: 10,
            border: "1px solid #cbd5e1",
            fontWeight: 800,
          }}
        >
          <option value="all">All sources</option>
          <option value="manual_invite">Manual Invite</option>
          <option value="facebook">Facebook</option>
          <option value="linkedin">LinkedIn</option>
          <option value="indeed">Indeed</option>
          <option value="referral">Referral</option>
          <option value="qr_code">QR Code</option>
          <option value="website">Website</option>
          <option value="facility_campaign">Facility Campaign</option>
        </select>

        <select
          value={pipelineStageFilter}
          onChange={(e) => setPipelineStageFilter(e.target.value)}
          style={{
            padding: 10,
            borderRadius: 10,
            border: "1px solid #cbd5e1",
            fontWeight: 800,
          }}
        >
          <option value="all">All stages</option>
          <option value="invited">Invited</option>
          <option value="registered">Registered</option>
          <option value="onboarding">Onboarding</option>
          <option value="review_queue">Review Queue</option>
          <option value="approved">Approved</option>
          <option value="action_required">Action Required</option>
        </select>
   </div>

      {children}
    </div>
  );
}